import { render } from "./Fragmentation.vue?vue&type=template&id=59afd76a&scoped=true"
import script from "./Fragmentation.vue?vue&type=script&lang=js"
export * from "./Fragmentation.vue?vue&type=script&lang=js"

import "./Fragmentation.vue?vue&type=style&index=0&id=59afd76a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59afd76a"]])

export default __exports__